export default __webpack_public_path__ + "static/media/ddsu5168_2p_wireless_4g.6b21e15e.jpg";